import { FC } from 'react';
import classnames from 'classnames';
import { Input } from 'rsuite';
import styles from './input.module.scss';

interface RsTextAreaProps {
  value: string;
  onChange: (s: string) => void;
  className?: string;
  disabled?: boolean;
}

export const RsTextArea: FC<RsTextAreaProps> = ({
  value,
  onChange = () => undefined,
  className = '',
  disabled = false,
}) => {
  return (
    <Input
      as='textarea'
      rows={3}
      value={value}
      onChange={onChange}
      className={classnames(styles.RsTextArea, className)}
      disabled={disabled}
    />
  );
};
